import { Injectable, signal } from '@angular/core';
import { IDefaultService, IDefaultServiceOption, IRecall } from '@core/interface';

@Injectable({
  providedIn: 'root',
})
export class MockService {
  selectedRevision = signal<IDefaultService | null>(null);
  recalls = signal<IRecall[] | null>(null);
  additionalServices = signal<IDefaultServiceOption[] | null>(null);

  remoteExperience = {
    modality: 'Serviço Móvel',
    budget: {
      price: 300,
      applicableDiscount: 0,
      total: 300
    }
  }
}
